import { render, staticRenderFns } from "./CorpAccounts.vue?vue&type=template&id=912252d4&scoped=true&"
import script from "./CorpAccounts.vue?vue&type=script&lang=js&"
export * from "./CorpAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912252d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('912252d4')) {
      api.createRecord('912252d4', component.options)
    } else {
      api.reload('912252d4', component.options)
    }
    module.hot.accept("./CorpAccounts.vue?vue&type=template&id=912252d4&scoped=true&", function () {
      api.rerender('912252d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/CorpAccounts.vue"
export default component.exports